<template>
    <validation class="form-group" :class="{ hasError: hasErrors, hasSuccess: isValid }"  :validator="v" :name="name" :inputclass="inputclass">
        <label v-if="label != ''">{{label}} <sup v-if="isRequired" class="text-danger">*</sup></label>
        <textarea type="text" :disabled='isLoading' v-model.trim="data" class="form-control"  v-bind:class="[ (v.$error || verr[0]) ? 'border-danger' : '' , true ? inputclass : '' ]" :placeholder="placeholder" autocomplete="no"></textarea>
        <div v-if="verr[0]" class="form-text errors text-danger">{{verr[0]}}</div>
    </validation>
</template>

<script>

import { singleErrorExtractorMixin } from "vuelidate-error-extractor";

export default {
    mixins: [singleErrorExtractorMixin],
    props: {
        value: {
            type: String,
            default: ""
        },
        name: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            default: ""
        },
        inputclass :{
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        v: {
            type: Object,
            required: true
        },
        isLoading : {
            type: Boolean,
            default: false
        },
        isRequired : {
            type: Boolean,
            default: false
        },
        verr : {
            type: Array,
            default: []
        }
    },
    computed: {
        data: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            }
    }
}
};
</script>